import type { UserFlags } from "@brookbush/types";

import { useAuth } from "@clerk/nextjs";
import useSWR from "swr";

import fetcher from "~/utils/fetcher.client";

const useUserFlags = () => {
	const { userId } = useAuth();

	const {
		data: userFlags,
		isLoading: isLoadingUserFlags,
		mutate,
		...rest
	} = useSWR<UserFlags>(userId && "/users/flags");

	const updateFlag = async (
		val: {
			[K in keyof UserFlags]: UserFlags[K];
		},
	) => {
		await mutate(
			fetcher(`/users/flags`, {
				method: "PUT",
				data: val,
			}),

			{
				populateCache: () => ({
					...userFlags,
					...val,
				}),
			},
		);
	};

	return {
		userFlags,
		isLoadingUserFlags,
		updateFlag,

		refreshUserFlags: () => mutate(),
		...rest,
	};
};

export default useUserFlags;
